import api from '../../lib/api';

export type CustomerProfilePhoneNumber = {
  id: number;
  phone_number: string;
  source: string;
  is_primary: boolean;
  is_verified: boolean;
  login_enabled: boolean;
};

export type CustomerProfile = {
  customer_id: number;
  last_name: string | null;
  first_name: string | null;
  gender: 'male' | 'female' | 'other' | null;
  birthday: string | null;
  nationality: string | null;
  province: string | null;
  district: string | null;
  area: string | null;
  phone_numbers: CustomerProfilePhoneNumber[];
};

export type CustomerProfilePayload = {
  last_name: string;
  first_name: string;
  gender: 'male' | 'female' | 'other' | '';
  birthday: string | null;
  nationality: string | null;
  province: string | null;
  district: string | null;
  area: string | null;
};

export const fetchCustomerProfile = async (): Promise<CustomerProfile> => {
  const res = await api.get<{ customer: CustomerProfile }>('/api/customer-app/profile');
  return res.data.customer;
};

export const updateCustomerProfile = async (
  payload: CustomerProfilePayload
): Promise<CustomerProfile> => {
  const res = await api.patch<{ customer: CustomerProfile }>('/api/customer-app/profile', payload);
  return res.data.customer;
};

export const addCustomerProfilePhoneNumber = async (
  phoneNumber: string
): Promise<CustomerProfile> => {
  const res = await api.post<{ customer: CustomerProfile }>('/api/customer-app/profile/phone-numbers', {
    phone_number: phoneNumber,
  });
  return res.data.customer;
};
